import excursionApi from "@/services/api/Excursion";
import { ExcursionAdditionDTO } from "@/services/api/Excursion/dtos";
import IExcursion from "@/services/api/Excursion/IExcursion";
import { ExcursionStatus } from "@/types/types";
import { uploadOriginalAndPreviewImagesToFirebase } from "@/utils/firebase/functions";
import { getExcursionsFirebasePath } from "@/utils/stringUtils";

export const EXCURSION_OPERATION_STEPS = [
  "Dados gerais",
  "Detalhes",
  "Localização",
  "Imagens",
];

export const handleCreateExcursion = async (
  excursionAdditionDto: ExcursionAdditionDTO,
  storeName: string
) => {
  const newExcursion: IExcursion = {
    storeId: excursionAdditionDto.storeId,
    title: excursionAdditionDto.title,
    mainCategory: excursionAdditionDto.mainCategory,
    price: excursionAdditionDto.price,
    agent: excursionAdditionDto.agent,
    startDate: excursionAdditionDto.startDate,
    endDate: excursionAdditionDto.endDate,
    minVacancies: excursionAdditionDto.minVacancies,
    maxVacancies: excursionAdditionDto.maxVacancies,
    description: excursionAdditionDto.description,
    transportService: excursionAdditionDto.transportService,
    accommodationService: excursionAdditionDto.accommodationService,
    foodService: excursionAdditionDto.foodService,
    excursionContract: excursionAdditionDto.excursionContract,
    groupLink: excursionAdditionDto.groupLink,
    router: excursionAdditionDto.router,
    city: excursionAdditionDto.city,
    state: excursionAdditionDto.state,
    region: excursionAdditionDto.region,
    country: excursionAdditionDto.country,
    imageOriginal: [],
    imagePreview: [],
    excursionStatus: ExcursionStatus.ACTIVE,
  };

  const createdExcursionResponse =
    await excursionApi.createExcursion(newExcursion);

  if (excursionAdditionDto.images.length > 0) {
    const { originalImageUrls, previewImageUrls } =
      await uploadOriginalAndPreviewImagesToFirebase(
        excursionAdditionDto.images,
        getExcursionsFirebasePath(
          storeName,
          createdExcursionResponse.storeId,
          createdExcursionResponse?.title,
          createdExcursionResponse?.id
        )
      );
    newExcursion.imageOriginal = originalImageUrls;
    newExcursion.imagePreview = previewImageUrls;

    delete newExcursion.storeId;

    const updatedStoreResponse = await excursionApi.updateExcursion(
      createdExcursionResponse.id,
      newExcursion
    );

    return updatedStoreResponse;
  }

  return createdExcursionResponse;
};
